import { useEffect } from 'react';
import { NextRouter } from 'next/router';
import domesticFilterStorage from 'storage/domesticFilter';
import { setFilterStorage } from 'list/international/filter/filterStore';

interface IProps {
  router: NextRouter;
}

function useNxAirlineParam({ router }: IProps) {
  const { alc, aln } = router.query;
  if (alc && aln) {
    const airlineCode = { [alc as string]: aln };
    if (router.pathname.includes('domestic')) {
      domesticFilterStorage.set({ airlineCode });
    } else {
      setFilterStorage({ airlines: airlineCode });
    }
  }
  useEffect(() => {
    if (alc && aln) {
      router.push(router.asPath.replace(/&?al[cn]{1}=[^&]*/g, ''));
    }
  }, []);
}

export default useNxAirlineParam;
